module.exports = __webpack_public_path__ + "img/film-preestirat.d69a239e.jpg";